export { default as ServicesTemplate } from './ServicesTemplate';
